<template>
  <div class="z-card">
    <h2>{{ $t('tasks.campaign.form.scripts.title') }}</h2>
    <div v-for="(script, i) in scripts" :key="i" class="mt-4">
      <h3>{{ script.name }}</h3>
      <p class="border mt-3 p-3">{{ script.content }}</p>
    </div>
  </div>
</template>

<script>
  import { ScriptsService } from '@administration/services/ScriptsService'
  export default {
    props: {
      project_id: {
        type: [String, Number],
        required: true
      }
    },
    data() {
      return {
        scripts: []
      }
    },
    created() {
      ScriptsService.getProjectList(this.project_id).then( data => this.scripts = data)
    }
  }
</script>
